"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ProductQuery = (0, graphql_tag_1.default) `
  query productQuery(
    $productId: String
    $partnerId: String
    $sellerId: String
    $zipcode: String
    $termsSize: Int = 20
    $includeTerms: Boolean = false
    $includeDescription: Boolean = false
    $showUnavailable: Boolean = false
    $showPayment: Boolean = false
    $pmdPromoter: String
    $storeId: String
    $channelCode: String
    $customerId: String
    $isLoyalty: Boolean
  ) {
    product(
      productRequest: {
        id: $productId
        partnerId: $partnerId
        sellerId: $sellerId
        showDescription: $includeDescription
        showUnavailable: $showUnavailable
        showPayment: $showPayment
        zipcode: $zipcode
        metadata: {
          customerId: $customerId
          loyaltyParams: { pmdPromoter: $pmdPromoter, storeId: $storeId }
          channelCode: $channelCode
          isLoyalty: $isLoyalty
        }
      }
    ) {
      isBuyBox
      id
      available
      title
      reference
      image
      terms(termsSize: $termsSize) @include(if: $includeTerms)
      description @include(if: $includeDescription)
      isOnWishlist
      type
      variationId
      path
      offerTags
      url
      minimumOrderQuantity
    }
  }
`;
exports.default = ProductQuery;
